import script from "./InvoiceCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvoiceCard.vue?vue&type=script&setup=true&lang=ts"

import "./InvoiceCard.vue?vue&type=style&index=0&id=889f48de&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-889f48de"]])

export default __exports__